import type { ActiveTool } from "../types";

/**
 * The drawer tabs connected tools ask for: one per tool with its own tab, then
 * one shared Tools tab if any tool sits there. A tool with no tab adds none.
 */
export function toolLeadTabs(tools: ActiveTool[] | undefined): { label: string; value: string }[] {
  const list = tools ?? [];
  const own = list
    .filter((t) => t.placement.tab === "own")
    .map((t) => ({ label: t.placement.tabLabel || t.name, value: `tool:${t.id}` }));
  const shared = list.some((t) => t.placement.tab === "shared") ? [{ label: "Tools", value: "Tools" }] : [];
  return [...own, ...shared];
}
